export const CHECKOUT_URL = 'https://taekwondo-instructor-ready.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/kGaH2i88FAZZGPQYfWU8Gb/Diseno_sin_titulo_(65).png'

export const packageIncludes = [
  '✅ Volume 1 — Taekwondo Foundations & Instructor Methodology',
  '✅ Volume 2 — Kicking Mechanics, Footwork & Technical Progressions',
  '✅ Volume 3 — Hand Techniques, Blocks, Stances & Combination Systems',
  '✅ Volume 4 — Poomsae, Forms & Technical Performance System',
  '✅ Volume 5 — Sparring, Distance, Timing & Tactical Development',
  '✅ Volume 6 — 150 Ready-to-Teach Taekwondo Sessions',
  '✅ Volume 7 — Advanced Coaching, Student Development & Instructor Toolkit',
  '🎁 Competition Preparation & Coaching Guide',
  '🎁 Dojang Class Management & Instructor Leadership System',
  '🎁 100 Taekwondo Skill Games, Challenges & Competitive Drills',
  '🎁 Student Motivation, Parent Communication & Retention Guide',
  '🎁 Taekwondo Demonstration Team & Performance Coaching Guide',
  '✅ Immediate Digital Access',
  '✅ PDF Format',
]

export const finalIncludedItems = [
  '7 Complete Volumes',
  '150 Ready-to-Teach Taekwondo Sessions',
  'Technical Progressions',
  'Kicking Systems',
  'Poomsae Development',
  'Sparring & Tactical Training',
  'Student Development Systems',
  'Professional Instructor Tools',
  '5 Bonus Guides',
  'Immediate Digital Access',
  'PDF Format',
]
